import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto",
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	}
}));

const enhanceWhatsappAvatarUrl = (value) => {
	const raw = String(value || "").trim();
	if (!raw) return raw;
	try {
		const parsed = new URL(raw, window.location.origin);
		const host = String(parsed.hostname || "").toLowerCase();
		if (!host.includes("whatsapp.net")) return raw;
		const stp = parsed.searchParams.get("stp");
		if (stp && /_s\d+x\d+/i.test(stp)) {
			parsed.searchParams.set("stp", stp.replace(/_s\d+x\d+/ig, ""));
		}
		return parsed.toString();
	} catch {
		return raw;
	}
};

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const [largeUrl, setLargeUrl] = useState("");

	useEffect(() => {
		if (!imageUrl) return;

		let objectUrl = null;
		const fetchImage = async () => {
			const enhancedImageUrl = enhanceWhatsappAvatarUrl(imageUrl);
			try {
				// Some records can contain malformed URLs and crash XHR open().
				// If URL parsing fails, keep the original URL as fallback.
				new URL(enhancedImageUrl, window.location.origin);
				const { data, headers } = await api.get(enhancedImageUrl, {
					responseType: "blob",
				});
				objectUrl = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				setBlobUrl(objectUrl);
				setLargeUrl(enhancedImageUrl);
			} catch (error) {
				setBlobUrl(enhancedImageUrl);
				setLargeUrl(enhancedImageUrl);
			} finally {
				setFetching(false);
			}
		};
		fetchImage();

		return () => {
			if (objectUrl) {
				window.URL.revokeObjectURL(objectUrl);
			}
		};
	}, [imageUrl]);

	return (
		<ModalImage
			className={classes.messageMedia}
			small={fetching ? imageUrl : blobUrl}
			medium={fetching ? imageUrl : blobUrl}
			large={fetching ? imageUrl : (largeUrl || blobUrl)}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
